import { yupResolver } from '@hookform/resolvers/yup'
import { DuplicateInfoDto, useGetActiveCreditAppLinkedToCellPhoneOrEmail } from '@src/api/credit-api'
import { ScrollableAlert } from '@src/components'
import PhoneInput from '@src/components/PhoneInput'
import { helpTip } from '@src/services/utils'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { ContactInformationInput, ContactInformationInputSchema } from './PrequalificationSchema'
import { FORM_ID } from './StepperFormFooter'

interface Props {
  applicantData: ContactInformationInput
  onApplicantUpdated: (data: ContactInformationInput) => void
  prohibedPhone?: string
}

const ContactInformationForm = ({ applicantData, onApplicantUpdated, prohibedPhone }: Props) => {
  const { t } = useTranslation()

  const {
    handleSubmit,
    control,
    register,
    formState: { errors },
  } = useForm<ContactInformationInput>({
    mode: 'onBlur',
    resolver: yupResolver(ContactInformationInputSchema),
    defaultValues: { ...applicantData, applicantPhoneNumber: prohibedPhone },
  })

  useEffect(() => {
    helpTip()
  }, [])

  const [hasDuplicateLoanRequest, setHasDuplicateLoanRequest] = useState(false)

  const [activeCreditAppLinkedToCellPhoneOrEmail] = useGetActiveCreditAppLinkedToCellPhoneOrEmail()

  const onSubmit = async (data: ContactInformationInput) => {
    const dto: DuplicateInfoDto = {
      email: data.email,
      cellPhone: data.cellPhone,
    }
    const isDuplicateRequest = await activeCreditAppLinkedToCellPhoneOrEmail(dto)
    if (!isDuplicateRequest) {
      onApplicantUpdated(data)
    } else {
      setHasDuplicateLoanRequest(true)
    }
  }

  return (
    <section className="step-content">
      <h3 className="form-question">{t('contact.provideInformation')}</h3>
      <form onSubmit={handleSubmit(onSubmit)} id={FORM_ID}>
        <ScrollableAlert
          showAlert={hasDuplicateLoanRequest}
          type="warn"
          message={t('contact.hasActiveLoanRequest')}
          link={t('contact.icebergPhone')}
          linkText={t('contact.icebergPhone')}
          linkType="tel"
        />
        <div className="control-group-wrap" style={{ alignItems: 'start' }}>
          <PhoneInput className="mid" control={control} name="cellPhone" label={t('contact.mobilePhone')} />
          <PhoneInput className="mid" control={control} name="homePhone" label={t('contact.otherPhone')} />
        </div>
        <div className={`control-group  ${errors.email && 'error'}`}>
          <label htmlFor="email">
            {t('contact.emailAddress')}
            <span className="help-tip">
              <p>{t('contact.emailAddressInfo')}</p>
            </span>
          </label>
          <input id="email" type="email" {...register('email')} maxLength={60} />
        </div>

        {/*  SUBSCRIBE NEWSLATTER AFTER MVP !IMPORTANT */}
        <div className="empty-space" />
        <div className="clarification">
          <p>
            {t('contact.newsletter')}
            <u>
              <a href={t('common.policyLink')} target="_blank" rel="noreferrer">
                {t('contact.linkText')}
              </a>
            </u>
            {t('contact.newsletterEnd')}
          </p>
        </div>
        <div className="control-group">
          <input type="checkbox" id="newsletter" {...register('subscribeNewsletter')} />
          <label htmlFor="newsletter">{t('contact.subscribe')}</label>
        </div>
      </form>
    </section>
  )
}

export default ContactInformationForm
